/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { Button, Col, Label, FormGroup } from 'reactstrap';
import {FaQuestionCircle} from 'react-icons/fa';
import ErrorGif from '../../Assets/images/Error.gif';
import * as ErrorMessage from '../../Resources/ErrorMessages';
// import PasswordStrength from '../../Resources/PasswordStrength';


class ChangePassword extends Component {

    constructor(props) {
        super(props)
        this.state = {
            old_password :null,
            new_password :"",
            confirm_password :null,
            succesfully_updated:false,
            error_msg: false,
            error_msg_type:null,
            password_strength:null,
          };
           this.SubmitChangePasswordForm = this.SubmitChangePasswordForm.bind(this);
     }

        SubmitChangePasswordForm(event) {
            event.preventDefault();
            const {old_password, new_password,confirm_password } = this.state;
            this.setState({
                error_msg: false, error_msg_type:null,
            });
            if(old_password === null ||old_password === "" ||old_password === undefined ||new_password === null ||new_password === "" ||new_password === undefined ){
                this.setState({    error_msg: true,error_msg_type:ErrorMessage.no_values });
            }
           else if(new_password !== confirm_password){
                this.setState({    error_msg: true,error_msg_type:ErrorMessage.passwords_doesnt_match });
            }

            else{
                // PasswordStrength.checkStrength(new_password);

                var formData = {
                    "oldPassword": this.state.old_password,
                    "NewPassword": this.state.new_password,
                  };
                  
                 // var tenant_Id = this.state.TenantID;
                  // this.props.PutTenantDetailsAction(editData,tenant_Id);
                   console.log(formData);
            }
            // const matches = new_password === confirm_password;
            //  matches ? alert("MATCHED") : alert("NO MATCH");  

           
           }



    render() {
        let Error_Message,initial_form, After_sucess_Content,content_tobe_displayed = null;
        let {error_msg_type,password_strength} = this.state;

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {error_msg_type}</p> : Error_Message = " ";


   //Initial Form         
        initial_form =      <form onSubmit={this.SubmitChangePasswordForm}>
                                    <div className="dbd_container">
                                        <div className="admin_page_titlebar">
                                            <div className="admin_subheader">
                                                <h2 className="dbd_sub_heading">Change Password</h2>
                                                <FaQuestionCircle className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" />
                                            </div>
                                            <p className="sub_text">Enter the current password once and a new password twice, and click Change Password.</p>
                                        </div>

                                        <div className="main_container dbd_main_container">
                                            {Error_Message}

                                            <div className="add_modifi form_group ">
                                                <Label className="Custom_label">Old Password</Label>
                                                <input className="add_modify custom_input default-input" defaultValue={this.state.old_password} onChange={e => this.setState({ old_password: e.target.value })} />
                                            </div>
                                            <div className="add_modifi form_group ">
                                                <Label className="Custom_label">New Password</Label>
                                                <input className="add_modify custom_input default-input" defaultValue={this.state.new_password} />
                                                <p className={password_strength}>{password_strength}</p>
                                            </div>

                                            <div className="add_modifi form_group ">
                                                <Label className="Custom_label">Confirm Password</Label>
                                                <input className="add_modify custom_input default-input" defaultValue={this.state.confirm_password} onChange={e => this.setState({ confirm_password: e.target.value })} />
                                            </div>

                                            <FormGroup row className="btns_group">
                                                <Col sm={{ size: 10 }}>
                                                    <Button type="submit" className="btn-success btn-md"  > {"Change Password"} </Button>
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </div>
                              </form>;

    // Success Content

    After_sucess_Content =    <div className="dbd_container">
                                    <div className="admin_page_titlebar">
                                        <div className="admin_subheader">
                                            <h2 className="dbd_sub_heading">Change Password</h2>
                                            <FaQuestionCircle className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" />
                                        </div>
                                        <p className="sub_text">Your password has been successfully changed.</p>
                                    </div>

                                    <div className="main_container dbd_main_container">
                                    {/* <p className="sub_text">You may go to any portion of the application you like by using the options at the top of the page or clicking one of the following. </p> */}
                                      
                                    </div>
                                </div>;

        content_tobe_displayed = (this.state.succesfully_updated === false ) ? <div>{initial_form} </div> : <div> {After_sucess_Content}</div>;
                              
        return (
            <div>
          {content_tobe_displayed}
            </div>
        );
    }
}


export default ChangePassword;
